<template>
  <AttrSwitch
    label="重着色为主题色"
    :value="disabled ? false : !!props.shape.attrs.recolorEnable"
    class="mt-2.5"
    :disabled="disabled"
    @change="onChange"
  />
  <div v-if="disabled" class="text-center mt-2 opacity-70">
    该元素不支持重着色
  </div>
</template>

<script lang="ts" setup>
import { Shape, ShapeType } from '@/services/shape';
import { canUse } from '@/utils/can-use.utils';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { computed, PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const watchStore = useWatchfaceStore();

const disabled = computed(() => {
  const type = props.shape.type;
  // 序列帧和视频表盘不支持重着色
  if (type == ShapeType.Sprite || type == ShapeType.VideoWatchface) return true;
  // 文字表盘仅 Q61 支持重着色
  if (type == ShapeType.TextWatchface && !canUse('text-watchface-recolor', watchStore.deviceType).valid) return true;
  return false;
});

const onChange = (val: number) => {
  props.shape.setAttrs({
    recolorEnable: val == 0 ? false : true
  });
};
</script>
